module.exports = __webpack_public_path__ + "DINNextLTPro-MediumCond.ttf?c7f97be7576b3ca232a510061655593e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-MediumCond.ttf
// module id = 1444
// module chunks = 0